import theme from 'presentation/styles/theme'
import styled, { css } from 'styled-components'
import { CardProps } from '.'

enum ShadowTypes {
  none = 'none',
  small = '2px 2px 2px rgba(0, 0, 0, 0.06)',
  medium = '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
  large = '',
  default = '0px 12px 18px rgba(0, 0, 0, 0.1)'
}

const BorderTypes = {
  none: 'none',
  disabled: `1px solid ${theme.ds.colors.neutral200}`,
  style1: `1px solid ${theme.ds.colors.primary100}`,
  style2: `1px solid ${theme.ds.colors.neutral200}`
}

export const CardWrapper = styled.div<CardProps>`
  ${({
    theme,
    shadow = 'default',
    border = 'none',
    radius = 'small',
    background = 'white',
    color = 'neutral900',
    padding = '16px',
    gap,
    disabled,
    onClick
  }) => css`
    display: flex;
    flex-direction: column;
    color: ${disabled ? theme.ds.colors.neutral400 : theme.ds.colors[color]};
    background: ${disabled
      ? theme.ds.colors.neutral100
      : theme.ds.colors[background]};
    box-shadow: ${ShadowTypes[shadow]};
    border: ${BorderTypes[disabled ? 'disabled' : border]};
    border-radius: ${theme.ds.typography.border.radius[radius]};
    padding: ${padding};
    gap: ${gap || '0px'};
    cursor: ${onClick && !disabled ? 'pointer' : 'default'};
    svg {
      path {
        stroke: ${disabled ? theme.ds.colors.neutral400 : ''};
      }
    }
  `}
`
